<div class="p-header-logout">
    <button class="p-header-logout__link" (click)="openModal()">
      <span>{{ "header.logout-text" | translate }}</span>
    </button>
  </div>
  
  <ng-template #modalBody>
    <div class="modal-body">
      {{'logout-modal.body' | translate}}
      </div>
  </ng-template>